var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['splash-css']},[_c('img',{class:_vm.$style['paddB'],attrs:{"src":require("../assets/image/cluna/splash.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }